import React from 'react';
import { Text, TouchableOpacity } from 'react-native';
import { LocStr } from '../../../utils/Utils';

//= ========================================================================
const EditOrderButton = ({
  onPress,
  language,
  backgroundColor,
  textColor,
  text,
}) => {
  const myStyle = {
    TextStyle: {
      fontSize: 16,
      color: textColor && '#fff',
    },
    background: {
      paddingHorizontal: 24,
      paddingVertical: 6,
      borderRadius: 4,
      backgroundColor: backgroundColor && '#008cff',
    },
  };
  return (
    <TouchableOpacity
      style={myStyle.background}
      onPress={onPress}
    >
      <Text style={myStyle.TextStyle}>{LocStr(text, language)}</Text>
    </TouchableOpacity>
  );
};

export default EditOrderButton;
